<script setup lang="ts">
import RlSearchCard from '@/components/common/RlSearchCard.vue'
import type { IMinerIdentifier } from '@/types/rc/miners'
import { MinerStatus, MinerStatusTagTypes } from '@/types/rc/miners/MinerStatus'
import { computed } from 'vue'
import { truncateSN } from '@/helpers/rc'

const props = defineProps<{ miner: IMinerIdentifier }>()

const tagType = computed(() => MinerStatusTagTypes[props.miner.status as MinerStatus])

const detailItems = computed(() => [
  { header: 'Model', value: props.miner.model },
  { header: 'Mac Address', value: props.miner.mac_address ?? 'N/A' },
])
</script>

<template>
  <rl-search-card :detail-items="detailItems">
    <template #header>
      <h5><span class="font-bold text-tertiary">SN:</span> {{ truncateSN(miner.sn, 22) }}</h5>
      <el-tag disable-transitions :type="tagType">{{ miner.status }}</el-tag>
    </template>
  </rl-search-card>
</template>
